import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../helpers/reselectHelpers';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
  WorkspaceDisplayActionsEnum,
  WorkspaceDisplaySectionTrackingTypesEnum,
} from '../../../../services/tracking';
import {WorkspaceDropReorderTeammateHandler} from '../../../../store/data/workspace/reorder/types';
import {hideWorkspaceLensAsyncAction} from '../../../../store/data/workspace/workspaceActions';
import {startedEditingWorkspacesAction} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {canDropWorkspaceItemAtTarget} from '../dnd/workspaceDragDropHelpers';
import {WorkspaceDragSourceTypesEnum, WorkspaceItemDropHandler} from '../dnd/workspaceDragDropTypes';
import {WorkspaceItemContainerProps, workspaceItemMapStateToProps} from '../workspaceItemContainerHelpers';
import {LensesWorkspaceItemContainerComponent} from './lensesWorkspaceItemContainerComponent';

interface LensWorkspaceItemContainerBaseProps extends WorkspaceItemContainerProps {
  onDropReorderLens: WorkspaceDropReorderTeammateHandler;
}

const mapDispatchToProps = makeMapDispatchToProps<LensWorkspaceItemContainerBaseProps>()(({panelId}) => ({
  editWorkspaces: (hasRarelyViewedItems: boolean) => {
    trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CLICK, {
      action: WorkspaceDisplayActionsEnum.VIEW_SIDEBAR,
      section: WorkspaceDisplaySectionTrackingTypesEnum.LENS,
    });
    return startedEditingWorkspacesAction(panelId, hasRarelyViewedItems);
  },
  hideWorkspaceLensAsync: hideWorkspaceLensAsyncAction,
}));

export const LensesWorkspaceItemContainerBase = connect(
  workspaceItemMapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {editWorkspaces, hideWorkspaceLensAsync} = dispatchProps;
    const {hasRarelyViewedItems} = stateProps;

    const onWorkspaceItemDrop: WorkspaceItemDropHandler = (droppedItem, linePosition, target) => {
      if (!target || !canDropWorkspaceItemAtTarget(droppedItem, target)) {
        return;
      }

      if (
        droppedItem.type !== WorkspaceDragSourceTypesEnum.LENS ||
        target.type !== WorkspaceDragSourceTypesEnum.LENS
      ) {
        return;
      }

      ownProps.onDropReorderLens({
        droppedItemId: droppedItem.id,
        targetItemId: target.id,
        linePosition,
      });
    };
    const onEditWorkspaces = () => {
      editWorkspaces(hasRarelyViewedItems);
    };
    return {
      ...ownProps,
      ...stateProps,
      onWorkspaceItemDrop,
      onEditWorkspaces,
      onHideFromWorkspace: hideWorkspaceLensAsync,
    };
  },
)(LensesWorkspaceItemContainerComponent);
